import { Component, Input, OnChanges } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormFieldOption, FormFieldSerializedValue, GroupedFormFieldOptions } from '@shared/shared/form-fields';
import { isObservable } from '@shared/core/utils';
import { FormFieldAbstractComponent } from '../abstract.component';
import { provideTranslation } from '@skyeng/libs/shared/i18n';

@Component({
  selector: 'crm-form-field-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  viewProviders: [provideTranslation('formFieldSelect', () => import.meta.webpackContext!('./translation'))],
})
export class FormFieldSelectComponent extends FormFieldAbstractComponent implements OnChanges {
  @Input() hideWithNoOptions = false;

  options$: Observable<FormFieldOption[]> = of([]);
  groupedOptions$: Observable<GroupedFormFieldOptions[]> = of([]);

  get readonlyValue$(): Observable<any> {
    let values = this.formFieldsService.serializeValues(this.parentFormGroup, [this.field])[
      this.field.key
    ] as FormFieldSerializedValue[];

    if (!Array.isArray(values)) {
      values = [values];
    }

    if (this.field.groupedOptions) {
      return this.groupedOptions$.pipe(
        map(groupOptionsList => {
          return values
            .map(val => {
              groupOptionsList.forEach(groupOptions => {
                const option = groupOptions.options.find(opt => val === opt.value) || { label: '' };
                return option.label;
              });
            })
            .join('; ');
        }),
      );
    } else {
      return this.options$.pipe(
        map(options => {
          return values
            .map(val => {
              const option = options.find(opt => val === opt.value) || { label: '' };
              return option.label;
            })
            .join('; ');
        }),
      );
    }
  }

  ngOnChanges(): void {
    this.setOptions();
  }

  private setOptions(): void {
    if (!this.field.options && !this.field.groupedOptions) {
      this.options$ = of([]);
      this.groupedOptions$ = of([]);
      return;
    }
    if (this.field.options) {
      this.options$ = isObservable(this.field.options) ? this.field.options : of(this.field.options);
    }

    if (this.field.groupedOptions) {
      this.groupedOptions$ = isObservable(this.field.groupedOptions)
        ? this.field.groupedOptions
        : of(this.field.groupedOptions);
    }
  }
}
